export default "__VITE_ASSET__BtIrxhG0__"